import { OrdersClient } from '@src/orders/services/OrdersClient';
import { useMutation } from '@tanstack/react-query';

export const useClaimPermit = ({
  orderId,
  permitId,
  onSuccess,
  onError,
}: {
  orderId: string;
  permitId: string;
  onSuccess: (userId: string) => void;
  onError: (error: Error) => void;
}) => {
  const { mutate, isPending } = useMutation({
    mutationFn: (userId: string) =>
      OrdersClient.claimPermit(orderId, permitId, { userId }),
    onSuccess: (_, userId) => {
      onSuccess(userId);
    },
    onError: (error: Error) => {
      onError(error);
    },
  });

  return {
    claimPermit: mutate,
    isPending,
  };
};
